const getters = {
  access_token: state => state.user.access_token,
  avatar: state => state.user.avatar,
  sidebar: state => state.app.sidebar,
  menu_status: state => state.permission.menuStatus,
  addRoutes: state => state.permission.addRoutes,
  permission_routes: state => state.permission.routes
}
export default getters
